import * as d3 from 'd3'
import Defs from '../../../../includes/primitives/colorDefs'

export default {
  methods: {

    draw_TubeChart() {
      let tube = this.tube
      let base = this.base

      let TubeChart = this.canvasForms
      .append('g')
      .attr('transform', `translate(25, 25)`)
      .style('font-family', 'roboto')

      tube.scale = d3.scaleLinear()
      .domain([0, 100])
      .rangeRound([tube.height, 0])

      Defs.setDefs_Reflections(TubeChart, this.localId)
      Defs.setDefs_Gradients(TubeChart, 0, 'LinearA2', tube.color, [1, 0.5, .5, 0.5], this.localId)
      Defs.setDefs_Gradients(TubeChart, 1, 'LinearA9', tube.color, [0, 0.5, 1, 0.5], this.localId)
      
      // Start from here
      TubeChart
      .append('g')
      .attr('transform', `translate(${tube.x + (tube.tickness/2)},${tube.y + (tube.tickness/4)})`)


      // ---------------------------  Reflected Effect
      TubeChart // Reflected Box
      .append('rect')
      .attr('transform', `translate(0, ${tube.height + tube.baseH})`)
      .attr('width', tube.tickness).attr('height', tube.baseH).attr('opacity', '0.75')
      .attr('fill', '#E0E0DF').attr('opacity', .5)

      TubeChart // Transparent Gradation Area
      .append('rect')
      .attr('transform', `translate(${-tube.tickness / 2},${tube.height + tube.baseH})`)
      .attr('width', tube.tickness * 2.5).attr('height', tube.baseH + 2)
      .attr('fill', `url(#${this.localId}__Color_Reflection)`)

      TubeChart // Shadow
      .append('ellipse')
      .attr('cx', tube.tickness / 4).attr('cy', tube.height + tube.baseH)
      .attr('rx', (tube.tickness * 1.5) / 2).attr('ry', (tube.tickness * 1.5) / 3 / 2)
      .attr('fill', `url(#${this.localId}_Shadow)`)


      // --------------------------- d.tube.baseH Cylinder
      TubeChart // Bottom Box
      .append('rect')
      .attr('transform', `translate(0,${tube.height})`)
      .attr('width', tube.tickness).attr('height', tube.baseH)
      .attr('fill', `url(#${this.localId}_TubeBase)`)

      TubeChart // Bottom Cap Bottom
      .append('ellipse')
      .attr('cx', tube.tickness / 2) .attr('cy', tube.height + tube.baseH)
      .attr('rx', tube.tickness / 2).attr('ry', tube.tickness / 3 / 2)
      .attr('fill', `url(#${this.localId}_TubeBase)`)


       // --------------------------- Tube Cylinder
       TubeChart
       .append('rect') // Tube Cylinder Box
       .attr('width', tube.tickness).attr('height', tube.height).attr('fill', `url(#${this.localId}_TubeBox)`).attr('opacity', 1)
 
       TubeChart // Bottom Cap
       .append('ellipse')
       .attr('cx', tube.tickness / 2).attr('cy', tube.height)
       .attr('rx', tube.tickness / 2).attr('ry', tube.tickness / 3 / 2).attr('fill', '#E0E0DF').attr('opacity', 0.9)
 
       TubeChart // Top Cap
       .append('ellipse')
       .attr('cx', tube.tickness / 2).attr('cy', 0)
       .attr('rx', tube.tickness / 2).attr('ry', tube.tickness / 3 / 2).attr('fill', `url(#${this.localId}_TubeCap)`)


       // --------------------------- Color Cylinder
       TubeChart
      .append('path') // Cyinder Box
      .attr('d', `
      M ${0} ${tube.scale(0)}
      V ${tube.scale(0)}
      C 0 ${((tube.tickness/3/2)*1.25) + tube.scale(0) } ${tube.tickness} ${((tube.tickness/3/2)*1.25) + tube.scale(0) } ${tube.tickness} ${tube.scale(0) } 
      V ${tube.scale(0)} 
      `)
      .attr('fill', `url(#${this.localId}_${tube.color}_1)`)
      
      .attr('opacity', .9)
      .transition()
      .duration(500)
      .attr('d', () => {
      let h_ = tube.scale(this.rawData.ACT_CUM)
      let hy = tube.scale(0) 

      return `
      M ${0} ${hy}
      V ${tube.scale(this.rawData.ACT_CUM)}
      C 0 ${((tube.tickness/3/2)*1.25) + h_} ${tube.tickness} ${((tube.tickness/3/2)*1.25) + h_} ${tube.tickness} ${h_} 
      V ${tube.scale(0)} 
      `
      })
    
      TubeChart // Bottom Cap
      .append('ellipse')
      .attr('cx', tube.tickness / 2).attr('cy', tube.height)
      .attr('rx', tube.tickness / 2).attr('ry', tube.tickness / 3 / 2).attr('fill', `url(#${this.localId}_${tube.color}_1)`)

      TubeChart // Top Cap
      .append('ellipse')
      .attr('cx', tube.tickness / 2).attr('cy', tube.scale(0))
      .attr('rx', tube.tickness / 2).attr('ry', tube.tickness / 3 / 2).attr('fill', `url(#${this.localId}_${tube.color}_0)`)
      .transition().duration(500).attr('cy', tube.scale(this.rawData.ACT_CUM))

      this.draw_Values(TubeChart)
    },




    
  }
}